var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contactum-field-options contactum-coupon-options" },
    [
      _c(
        "div",
        { staticClass: "contactum-option-row" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Placeholder Text")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "e.g. Enter coupon code", size: "small" },
            model: {
              value: _vm.editfield.placeholder,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "placeholder", $$v)
              },
              expression: "editfield.placeholder"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum-option-row" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Button Label")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "Apply", size: "small" },
            model: {
              value: _vm.editfield.button_label,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "button_label", $$v)
              },
              expression: "editfield.button_label"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum-option-row" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Success Message")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              placeholder: "Coupon applied successfully!",
              size: "small"
            },
            model: {
              value: _vm.editfield.success_message,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "success_message", $$v)
              },
              expression: "editfield.success_message"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum-option-row" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Error Message")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              placeholder: "Invalid or expired coupon code.",
              size: "small"
            },
            model: {
              value: _vm.editfield.error_message,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "error_message", $$v)
              },
              expression: "editfield.error_message"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum-option-row contactum-option-row--switch" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Show Discount Line in Total")
          ]),
          _vm._v(" "),
          _c("el-switch", {
            model: {
              value: _vm.editfield.show_discount_line,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "show_discount_line", $$v)
              },
              expression: "editfield.show_discount_line"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum-option-row contactum-option-row--switch" },
        [
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v("Auto-apply from URL (?coupon=CODE)")
          ]),
          _vm._v(" "),
          _c("el-switch", {
            model: {
              value: _vm.editfield.auto_apply,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "auto_apply", $$v)
              },
              expression: "editfield.auto_apply"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }